import {
  ISubscriptionsProlongCurrentSubscriptionRequest,
  ELevel,
} from '../../../repositories/billing-subscriptions/v2/subscriptions-prolong-current-subscription';
import { IProlongSubscriptionParameters } from '../types';

export const mapParameters = (
  parameters: IProlongSubscriptionParameters,
): ISubscriptionsProlongCurrentSubscriptionRequest => {
  const { level } = parameters;

  return {
    level: level as string as ELevel,
  };
};
